import { defineStore } from "pinia";
import { ref } from "vue";

export default defineStore("onboarding", () => {
  const shouldStart = ref(false);

  function start() {
    shouldStart.value = true;
  }
  function end() {
    shouldStart.value = false;
  }

  return { shouldStart, start, end };
});
